import React from "react"

const CameraIcon = (props) => (
  <svg
    {...props}
    width="21"
    height="18"
    viewBox="0 0 21 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.5 13.2C12.2673 13.2 13.7 11.7673 13.7 10C13.7 8.23269 12.2673 6.8 10.5 6.8C8.73269 6.8 7.3 8.23269 7.3 10C7.3 11.7673 8.73269 13.2 10.5 13.2Z" fill="#018762"/>
    <path d="M7.5 0L5.67 2H2.5C1.4 2 0.5 2.9 0.5 4V16C0.5 17.1 1.4 18 2.5 18H18.5C19.6 18 20.5 17.1 20.5 16V4C20.5 2.9 19.6 2 18.5 2H15.33L13.5 0H7.5ZM10.5 15C7.74 15 5.5 12.76 5.5 10C5.5 7.24 7.74 5 10.5 5C13.26 5 15.5 7.24 15.5 10C15.5 12.76 13.26 15 10.5 15Z" fill="#018762"/>
</svg>

)

export default CameraIcon